if (!window.Eurus?.loadedScript?.has("flip-usp.js")) {
	if (!window.Eurus) window.Eurus = {};
	if (!window.Eurus.loadedScript) window.Eurus.loadedScript = new Set();
	window.Eurus.loadedScript.add("flip-usp.js");

	(function () {
		function handleFlipCardClick(e) {
			// Prevent default link behavior if clicking on a link
			if (e.target.closest("a")) {
				return;
			}

			// Toggle flip state
			this.classList.toggle("flipped");
		}

		function initFlipCards() {
			const flipCards = document.querySelectorAll("[data-flip-card]");

			flipCards.forEach(function (card) {
				const hasListener = card.hasAttribute("data-flip-initialized");

				if (!hasListener && window.innerWidth < 1024) {
					card.addEventListener("click", handleFlipCardClick);
					card.setAttribute("data-flip-initialized", "true");
				} else if (hasListener && window.innerWidth >= 1024) {
					card.removeEventListener("click", handleFlipCardClick);
					card.removeAttribute("data-flip-initialized");
				}
			});
		}

		// Initialize on page load
		if (document.readyState === "loading") {
			document.addEventListener("DOMContentLoaded", initFlipCards);
		} else {
			initFlipCards();
		}

		// Handle window resize
		let isMobile = window.innerWidth < 1024;
		let resizeTimeout;
		window.addEventListener("resize", function () {
			clearTimeout(resizeTimeout);
			resizeTimeout = setTimeout(function () {
				const newIsMobile = window.innerWidth < 1024;
				if (newIsMobile !== isMobile) {
					isMobile = newIsMobile;
					// Remove flipped class when switching to desktop
					if (!isMobile) {
						const flipCards = document.querySelectorAll("[data-flip-card]");
						flipCards.forEach(function (card) {
							card.classList.remove("flipped");
						});
					}
					// Re-initialize click handlers
					initFlipCards();
				}
			}, 100);
		});
	})();
}